export default function () {
    const info = document.querySelector('.discount-info');

    if (!info) return;

    const strong = info.querySelector('strong');
    const priceText = strong ? strong.textContent.trim() : '';
    const percentText = (info.getAttribute('data-percent-discount-value') || '').trim();

    if (priceText === '' || percentText === '') return;

    const price = Number(priceText.replace(',', '.'));
    const percent = Number(percentText.replace(',', '.'));

    if (!Number.isFinite(price) || !Number.isFinite(percent)) return;

    strong.textContent = (price * (1 - percent / 100)).toFixed(2).replace('.', ',');
}
